import { render, staticRenderFns } from "./_header.vue?vue&type=template&id=6b0f4591&"
import script from "./_header.vue?vue&type=script&lang=js&"
export * from "./_header.vue?vue&type=script&lang=js&"
import style0 from "./_header.vue?vue&type=style&index=0&id=6b0f4591&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports